const config = {
    apiUrl: 'https://api.meianrj.cn/',
    //apiUrl: 'http://192.168.0.2:8200/',
    //apiUrl: 'http://192.168.1.250:8200/',
    webUrl: 'https://m.meianrj.cn/',
    //webUrl: 'http://192.168.43.53:8080/',
    proxyUrl: 'http://ma.meianrj.cn/mobile',
    captcha: false
  };

export default config;